import { makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

export const useMeasurementDateHeaderStyles = makeStyles((theme: ITheme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  date: {
    '& .MuiInputBase-input.Mui-disabled': {
      color: 'black',
    },
    '& .MuiIconButton-root.Mui-disabled': {
      color: `${theme.palette.primary.main}`,
    },
  },
}));
